"use client";

import React from "react";
import { Hexagon, Box, Layers, Check, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const capabilityCategories = [{
  id: 1,
  title: "Momentos Sagrados",
  iconName: "Hexagon"
}, {
  id: 2,
  title: "Regalos del Alma",
  iconName: "Box"
}, {
  id: 3,
  title: "Identidad Sonora",
  iconName: "Layers"
}];
const capabilityFeatures = [{
  categoryId: 1,
  text: "Música para Bodas"
}, {
  categoryId: 1,
  text: "Canciones de Fe Personalizadas"
}, {
  categoryId: 1,
  text: "Música para Eventos Familiares"
}, {
  categoryId: 2,
  text: "Canciones de Cumpleaños"
}, {
  categoryId: 2,
  text: "Homenajes Especiales"
}, {
  categoryId: 2,
  text: "Dedicatorias Musicales"
}, {
  categoryId: 3,
  text: "Música para Empresas"
}, {
  categoryId: 3,
  text: "Proyectos Especiales"
}, {
  categoryId: 3,
  text: "Producciones Institucionales"
}];
const iconMap: Record<string, React.ElementType> = {
  Hexagon: Hexagon,
  Box: Box,
  Layers: Layers
};
export default function TuHistoriaEnUnaCanciN() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222517" id="tu-historia-en-una-canción" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: `radial-gradient(circle at 2px 2px, var(--color-border) 1px, transparent 0)`,
      backgroundSize: '40px 40px'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mb-16 transition-all duration-1000 transform ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tighter mb-6">Tu Historia <span className="text-primary" data-ast-id="f:/src/pages/Home/sections/TuHistoriaEnUnaCanciN.tsx|sig:p8yc2l" data-ast-start="2264" data-ast-end="2441">en una Canción viva&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-2xl">
            Convertimos tus experiencias, recuerdos y fe en canciones personalizadas que preservan y celebran los momentos más importantes de tu vida.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilityCategories.map((category, index) => {
          const Icon = iconMap[category.iconName];
          const features = capabilityFeatures.filter(f => f.categoryId === category.id);
          return <div key={category.id} data-index={index} className={`transition-all duration-700 transform ${isGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} style={{
            transitionDelay: `${index * 150}ms`
          }}>
                <Card className="h-full bg-card/60 backdrop-blur-xl border-border/40 rounded-lg hover:border-primary/40 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 relative overflow-hidden group">
                  {}
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-secondary to-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="pb-4">
                    <div className="mb-6 inline-flex items-center justify-center p-4 bg-background border border-border/30 shadow-md rounded-lg relative">
                      {}
                      <div className="absolute inset-0 bg-primary/5 rounded-lg -z-10" />
                      <Icon className="size-8 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-3xl font-bold tracking-tight">
                      {category.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <ul className="space-y-4">
                      {features.map((feature, fIndex) => <li key={fIndex} data-index={fIndex} className="flex items-start gap-3">
                          <Check className="size-5 text-secondary shrink-0 mt-0.5" strokeWidth={2.5} />
                          <span className="font-default text-muted-foreground leading-snug">
                            {feature.text}
                          </span>
                        </li>)}
                    </ul>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-16 flex justify-center lg:justify-start">
          <Button asChild size="lg" className="rounded-lg font-default font-semibold uppercase tracking-wider bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20">
            <Link to="/PortfolioPage">
              Explora Nuestro Trabajo
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}